import { useAsyncModal } from '@ipfabric/frontend-shared-assets/utils/react/useAsyncModal';
import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { Button } from 'components/Button/Button';
import { ConfirmDialog } from 'containers/ConfirmDialog/ConfirmDialog';
import { DashboardLayoutTitleDialog } from 'pages/Dashboard/Overview/DashboardLayoutTitleDialog';
import { useConfirmDialog } from 'utils/hooks/useConfirmDialog';

const CONFIRM_DELETE_DIALOG = 'dashboardTabConfirmDeleteDialog';

export default function EditBar({
  onRenameLayout,
  onDeleteLayout,
  onSaveLayout,
  onSwitchEditLayoutMode,
  dashboard: { layout, layouts, layoutsDict, isEditLayoutMode },
}) {
  const confirmDeleteDialog = useConfirmDialog({ name: CONFIRM_DELETE_DIALOG });

  const renameLayoutModal = useAsyncModal();

  const renameLayout = useStableCallback(async (e) => {
    e.stopPropagation();
    e.preventDefault();

    const layoutTitle = await renameLayoutModal.show();

    if (layoutTitle !== null) {
      onRenameLayout({ layoutTitle, layout, layouts, layoutsDict });
    }
  });

  const toggleEditLayout = useStableCallback((e) => {
    e.stopPropagation();
    e.preventDefault();

    if (isEditLayoutMode) {
      onSaveLayout({ layout, layoutsDict });
    }

    onSwitchEditLayoutMode({ editMode: !isEditLayoutMode });
  });

  const deleteLayout = useStableCallback(() => {
    onDeleteLayout({ layout, layouts, layoutsDict });
  });

  const deleteDialogTexts = {
    header: 'Delete tab',
    subHeader: `Do you really want to delete tab "${layout.title}"?`,
    btnConfirm: 'Delete',
    btnSecondaryConfirm: 'Cancel',
  };

  const layoutTitles = layouts.map((layout) => layout.title);

  return (
    <>
      <ConfirmDialog
        id={CONFIRM_DELETE_DIALOG}
        msg={deleteDialogTexts}
        onClickConfirm={deleteLayout}
        onClickSecondaryConfirm={() => {
          confirmDeleteDialog.closeConfirmDialog();
        }}
        btnConfirmVariant='primary'
        btnConfirmAccent='negative'
        btnCancelVariant='secondary'
        btnCancelAccent='positive'
      />
      {renameLayoutModal.render((returnFromModal) => (
        <DashboardLayoutTitleDialog
          mode='edit'
          onClose={() => returnFromModal(null)}
          onConfirm={returnFromModal}
          initialLayoutTitle={layout.title}
          existingLayoutTitles={layoutTitles}
        />
      ))}
      <div className='flex justify-end gap-x-2'>
        {isEditLayoutMode ? (
          <Button
            type='button'
            variant='primary'
            icon='fa-check'
            onClick={toggleEditLayout}
          >
            Save
          </Button>
        ) : (
          <>
            <Button
              type='button'
              variant='secondary'
              icon='fa-gear'
              onClick={toggleEditLayout}
            >
              Edit
            </Button>
            <Button
              type='button'
              variant='secondary'
              icon='fa-pen'
              onClick={renameLayout}
            >
              Rename tab
            </Button>
            <Button
              type='button'
              variant='secondary'
              accent='negative'
              icon='fa-remove'
              onClick={() => {
                confirmDeleteDialog.toggleConfirmDialog();
              }}
              disabled={isEditLayoutMode}
            >
              Delete tab
            </Button>
          </>
        )}
      </div>
    </>
  );
}
